<template>
    <templateList :type="1"/>
</template>

<script>
import templateList from './templateList.vue'
let timer = null
export default {
    name: 'myChoice',
    components: {
        templateList,
    },
}
</script>
